import React, { useEffect, useMemo, useState } from "react";
import { GetSeatAvailability } from "../../Services/API";

const FlightSeatSelection = ({
    flightAvailibilies,
    seatSelections,
    setSeatSelections,
    keyParam,
    referenceNo,
}) => {

    const [seatData, setSeatData] = useState({});
    const [activeSegmentKey, setActiveSegmentKey] = useState(null);
    const [loading, setLoading] = useState(false);

    const [selectedPaxType, setSelectedPaxType] = useState(null);
    const [selectedPaxIndex, setSelectedPaxIndex] = useState(null);
    const [seatGridMap, setSeatGridMap] = useState({});

    const [activeTab, setActiveTab] = useState(null);
    /* ---------------- SEGMENTS ---------------- */
    const segments = useMemo(() => {
        return flightAvailibilies?.flatMap(f => f.segments) || [];
    }, [flightAvailibilies]);

    /* ---------------- DEFAULT SELECTION ---------------- */
    // useEffect(() => {
    //     if (segments.length && !activeSegmentKey) {
    //         const firstSeg = segments[0];
    //         const key = `${firstSeg.flightNumber}_${firstSeg.departAirportCode}_${firstSeg.arrivalAirportCode}`;
    //         setActiveSegmentKey(key);
    //         setSelectedPaxType("ADULT");
    //         setSelectedPaxIndex(0);
    //     }
    // }, [segments]);

    /* ---------------- FETCH API ---------------- */
    // useEffect(() => {
    //     if (!segments.length) return;
    //     fetchSeatData();
    // }, [segments]);

    const fetchSeatData = async () => {
        try {
            setLoading(true);

            await Promise.all(
                segments.map(async (seg, idx) => {

                    const segmentKey = `${seg.departAirportCode}_${seg.arrivalAirportCode}_${seg.flightNumber}_${seg.trackID || idx}`;

                    const payload = {
                        clientCode: "BerryJourneys",
                        key: keyParam,
                        referenceNo: referenceNo,
                        Origin: seg.departAirportCode,
                        Destination: seg.arrivalAirportCode,
                        Airline: seg.marketingCarrier || seg.airLineCode,
                        FlightNumber: seg.flightNumber,
                    };

                    const res = await GetSeatAvailability(payload);

                    const seats = res?.deckData?.seats || [];

                    // ✅ FORMAT GRID
                    const grid = {};

                    seats.forEach((seat) => {
                        const row = seat?.seatPos?.y;
                        const col = seat?.seatPos?.x;

                        if (!row || !col) return;

                        if (!grid[row]) grid[row] = [];

                        grid[row][col - 1] = seat;
                    });

                    return { segmentKey, grid }; // return data
                })
            ).then((results) => {

                const finalMap = {};

                results.forEach(item => {
                    finalMap[item.segmentKey] = item.grid;
                });

                setSeatGridMap(finalMap); // ✅ THIS WAS MISSING
            });

        } catch (err) {
            console.error("Seat API Error", err);
        } finally {
            setLoading(false);
        }
    };
    /* ---------------- SEATS ---------------- */
    const seatGrid = seatGridMap?.[activeSegmentKey] || {};
    /* ---------------- OCCUPIED ---------------- */
    const occupiedSeats = useMemo(() => {
        const set = new Set();

        const segmentSeats = seatSelections?.[activeSegmentKey] || {};

        Object.values(segmentSeats).forEach(paxGroup => {
            Object.values(paxGroup).forEach(seat => {
                if (seat?.seatCode) set.add(seat.seatCode);
            });
        });

        return set;
    }, [seatSelections, activeSegmentKey]);


    const handleSegmentClick = async (seg, idx) => {

        const segmentKey = `${seg.departAirportCode}_${seg.arrivalAirportCode}_${seg.flightNumber}_${seg.trackID || idx}`;

        setActiveSegmentKey(segmentKey);
        setSelectedPaxType("ADULT");
        setSelectedPaxIndex(0);

        // ✅ If already loaded, don't call API again
        if (seatGridMap[segmentKey]) return;

        try {
            setLoading(true);

            const payload = {
                clientCode: "BerryJourneys",
                key: keyParam,
                referenceNo: referenceNo,
                Origin: seg.departAirportCode,
                Destination: seg.arrivalAirportCode,
                Airline: seg.marketingCarrier || seg.airLineCode,
                FlightNumber: seg.flightNumber,
            };

            const res = await GetSeatAvailability(payload);

            const seats = res?.deckData?.seats || [];

            const grid = {};

            seats.forEach((seat) => {
                const row = seat?.seatPos?.y;
                const col = seat?.seatPos?.x;

                if (!row || !col) return;

                if (!grid[row]) grid[row] = [];

                grid[row][col - 1] = seat;
            });

            setSeatGridMap(prev => ({
                ...prev,
                [segmentKey]: grid
            }));

        } catch (err) {
            console.error("Seat API Error", err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- CLICK ---------------- */
    const handleSeatClick = (seat) => {

        if (!selectedPaxType) {
            alert("Select passenger first");
            return;
        }

        if (seat.booked || occupiedSeats.has(seat.code)) return;

        setSeatSelections(prev => {

            const updated = { ...prev };

            if (!updated[activeSegmentKey]) {
                updated[activeSegmentKey] = {};
            }

            if (!updated[activeSegmentKey][selectedPaxType]) {
                updated[activeSegmentKey][selectedPaxType] = {};
            }

            updated[activeSegmentKey][selectedPaxType][selectedPaxIndex] = {
                seatCode: seat.code,
                displaySeatNo: seat.seatNo,
                price: seat.amount || 0,
            };

            return updated;
        });
    };

    /* ---------------- RENDER SEAT ---------------- */
    const renderSeat = (seat, index, total, isExitRow) => {

        const isSelected =
            seatSelections?.[activeSegmentKey]?.[selectedPaxType]?.[selectedPaxIndex]?.seatCode === seat.code;

        const isOccupied = occupiedSeats.has(seat.code);

        const disabled = seat.booked || isOccupied;

        return (
            <div key={seat.code} style={{ position: "relative" }}>
                <button
                    disabled={disabled}
                    onClick={() => handleSeatClick(seat)}
                    style={{
                        width: 45,
                        height: 45,
                        backgroundColor: seat.booked
                            ? "#adb5bd"
                            : isSelected
                                ? "#198754"
                                : isOccupied
                                    ? "#6c757d"
                                    : isExitRow
                                        ? "#ffc107"
                                        : "#0d6efd",
                        color: "#fff",
                        borderRadius: 6,
                        border: isSelected ? "2px solid #14532d" : "1px solid #ddd",
                        fontSize: 12,
                        padding: 0,
                        cursor: disabled ? "not-allowed" : "pointer"
                    }}
                >
                    {isSelected ? "✔" : seat.seatNo}

                    {!isSelected && seat.amount > 0 && (
                        <div style={{ fontSize: 9 }}>₹{seat.amount}</div>
                    )}
                </button>
            </div>
        );
    };

    /* ---------------- TOTAL ---------------- */
    const segmentTotal = (segmentKey) => {
        return Object.values(seatSelections?.[segmentKey] || {}).reduce(
            (sum, paxGroup) =>
                sum +
                Object.values(paxGroup).reduce(
                    (paxSum, seat) => paxSum + Number(seat?.price || 0),
                    0
                ),
            0
        );
    };

    const totalAmount = Object.values(seatSelections || {}).reduce(
        (sum, segment) =>
            sum +
            Object.values(segment).reduce(
                (paxSum, paxGroup) =>
                    paxSum +
                    Object.values(paxGroup).reduce(
                        (seatSum, seat) => seatSum + Number(seat?.price || 0),
                        0
                    ),
                0
            ),
        0
    );

    /* ---------------- PAX ---------------- */
    const availability = flightAvailibilies?.[0] || {};
    const paxTypes = [
        { type: "ADULT", count: availability?.adult || 0 },
        { type: "CHILD", count: availability?.child || 0 },
    ];

    /* ---------------- UI (UNCHANGED) ---------------- */
    return (
        <div>
            <div className="flight-tabs mb-3">
                {segments.map((seg, idx) => (
                    <button
                        key={idx}
                        className={`del_uid_Sectr ${activeTab === idx ? "active-tab" : ""}`}
                        onClick={() => {
                            setActiveTab(idx);
                            handleSegmentClick(seg, idx); // keep your existing call
                        }}
                    >
                        {seg.airLineName} : {seg.airLineCode}-{seg.flightNumber}
                    </button>
                ))}
            </div>
            {activeTab === null && (
                <div className="text-center p-4">
                    <h6 style={{ color: 'red' }}>Please click on a flight tab to view seat availability</h6>
                </div>
            )}

            {segments.map((seg, idx) => {

                if (activeTab !== idx) return null;

                const segmentKey = `${seg.departAirportCode}_${seg.arrivalAirportCode}_${seg.flightNumber}_${seg.trackID || idx}`;

                const seatGrid = seatGridMap?.[segmentKey] || {};

                return (
                    <React.Fragment key={segmentKey}>
                        {loading && activeSegmentKey === segmentKey && (
                            <p className="text-center"><span className="loader"></span></p>
                        )}
                        {!loading && (
                            Object.keys(seatGrid || {}).length > 0 ? (
                                <div className="row Repeat_seat">

                                    {/* LEFT PANEL */}
                                    <div className="col-md-4">
                                        <div className="mb-4">
                                            <h6>{seg.departAirportCode} → {seg.arrivalAirportCode}</h6>

                                            <div className="pax_deal">

                                                <div className="mainSet">
                                                    <div>Pax</div>
                                                    <div>Seat</div>
                                                    <div>Fee</div>
                                                </div>

                                                {paxTypes.map(p =>
                                                    Array.from({ length: p.count }).map((_, i) => {

                                                        const selectedSeat =
                                                            seatSelections?.[segmentKey]?.[p.type]?.[i];

                                                        const isActive =
                                                            activeSegmentKey === segmentKey &&
                                                            selectedPaxType === p.type &&
                                                            selectedPaxIndex === i;

                                                        return (
                                                            <div
                                                                key={`${p.type}_${i}`}
                                                                className={`mainSet_selct ${isActive ? "active-pax" : ""}`}
                                                                onClick={() => {
                                                                    setActiveSegmentKey(segmentKey);
                                                                    setSelectedPaxType(p.type);
                                                                    setSelectedPaxIndex(i);
                                                                }}
                                                            >
                                                                <div>{p.type} {i + 1}</div>
                                                                <div>{selectedSeat?.displaySeatNo || "-"}</div>
                                                                <div>{selectedSeat ? `₹${selectedSeat.price}` : "-"}</div>
                                                            </div>
                                                        );
                                                    })
                                                )}

                                                <div className="mainSet">
                                                    <div>Total</div>
                                                    <div></div>
                                                    <div>₹{segmentTotal(segmentKey)}</div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    {/* RIGHT PANEL */}
                                    <div className="col-md-8">
                                        {/* {loading && activeSegmentKey === segmentKey && (
                                            <p className="text-center"><span className="loader"></span></p>
                                        )} */}
                                        {!loading && (
                                            <div className="row">
                                                <div className="col-md-12 Seat_flow">

                                                    <div className="cockpit">
                                                        <div className="cockpit-top">
                                                            <img src="/assets/images/cockpit-top.png" alt="Cockpit" />
                                                        </div>
                                                        <div className="front nws">Front</div>
                                                    </div>

                                                    <div className="col-md-12 seat-map">

                                                        <div className="d-flex exit">
                                                            <span>Exit</span>
                                                            <span>Exit</span>
                                                        </div>

                                                        {Object.keys(seatGrid)
                                                            .sort((a, b) => Number(a) - Number(b))
                                                            .map((rowKey) => {

                                                                const rowSeats = seatGrid[rowKey] || [];
                                                                if (!rowSeats.length) return null;

                                                                const aisleIndex = Math.ceil(rowSeats.length / 2);
                                                                const isExitRow = [12, 13].includes(Number(rowKey));

                                                                return (
                                                                    <div
                                                                        key={rowKey}
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            marginBottom: 12,
                                                                        }}
                                                                    >

                                                                        <div style={{ display: "flex", gap: 6 }}>
                                                                            {rowSeats.slice(0, aisleIndex).map((seat, idx) =>
                                                                                seat ? renderSeat(seat, idx, rowSeats.length, isExitRow) : null
                                                                            )}
                                                                        </div>

                                                                        <div style={{ width: 50 }} />

                                                                        <div style={{ display: "flex", gap: 6 }}>
                                                                            {rowSeats.slice(aisleIndex).map((seat, idx) =>
                                                                                seat
                                                                                    ? renderSeat(seat, idx + aisleIndex, rowSeats.length, isExitRow)
                                                                                    : null
                                                                            )}
                                                                        </div>

                                                                    </div>
                                                                );
                                                            })}

                                                        <div className="d-flex exit">
                                                            <span>Exit</span>
                                                            <span>Exit</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            ) : (
                                <>
                                    <div className="text-center p-4">
                                        <h6 style={{ color: 'red' }}>Seat map not found!!</h6>
                                    </div>
                                </>
                            )
                        )}
                    </React.Fragment>
                );
            })}


        </div>
    );
};

export default FlightSeatSelection;